export const ACTIVE_STATUS_CODE = 1;

export enum ActivityStatus
{
    Active = 1,
    Closed = 2,
    Void = 3 
}